/**
 * Escenarios temporales para estrategias de cobranza
 * Define cuándo se ejecutará la estrategia en relación a la fecha de vencimiento
 */
export enum ScenarioEnum {
  /** Antes de la fecha de vencimiento - Recordatorios preventivos */
  PRE_DUE_DATE = 'PRE_DUE_DATE',
  
  /** El día de la fecha de vencimiento - Avisos el día exacto */
  DUE_DATE = 'DUE_DATE',
  
  /** Después de la fecha de vencimiento - Cobranza por atraso */
  POST_DUE_DATE = 'POST_DUE_DATE',
}
